import { useLocation } from "react-router-dom";
import TermsPresenter from "./TermsPresenter";

export default function TermsContainer() {
  const { pathname } = useLocation();

  return <TermsPresenter pathname={pathname} />;
}
